export const firebaseConfig = {
  apiKey: "AIzaSyAfKI8_hsqBfmPGJfy4DzOa28UaNaoMBjs",
  authDomain: "staffsupportportal.firebaseapp.com",
  databaseURL: "https://staffsupportportal.firebaseio.com",
  projectId: "staffsupportportal",
  storageBucket: "staffsupportportal.appspot.com",
  messagingSenderId: "985697061675"
};